import { useLayoutEffect, useRef, useState } from 'react';

export const useResizeObserverState = (
  targetRef,
  { compute, enabled = true, defaultValue }
) => {
  const _compute = useRef(compute);
  _compute.current = compute;

  const [state, setState] = useState(
    () => _compute.current(targetRef.current) || defaultValue
  );

  useLayoutEffect(() => {
    const el = targetRef.current;

    if (el && enabled) {
      let RAFId = 0;

      const sheduleUpdate = () => {
        if (!RAFId) {
          RAFId = requestAnimationFrame(() => {
            RAFId = 0;
            setState(_compute.current(el));
          });
        }
      };

      const observer = new ResizeObserver(sheduleUpdate);
      observer.observe(el);

      return () => {
        observer.disconnect();
        if (RAFId) {
          cancelAnimationFrame(RAFId);
        }
      };
    }
  }, [targetRef, enabled]);

  return state;
};
